module.exports = __webpack_public_path__ + "img/1.878ca663.png";